import getCookie from "@/utils/getCookie";
import isWebApp from "@/utils/isWebApp";
import { FC, ReactNode } from "react";
import { Navigate, Outlet } from "react-router";

const PublicGuard: FC<{ children?: ReactNode }> = ({ children }) => {
  const accessToken = getCookie("accessToken");
  const refreshToken = getCookie("refreshToken");

  if ((accessToken && refreshToken) || isWebApp()) {
    return <Navigate to="/" replace />;
  }
  return children ?? <Outlet />;
};

export default PublicGuard;
